function reducer(state = [], action) {
    switch (action.type) {
        case 'DETAILS/SET':
            return action.details;
        case 'DETAILS/CLEAR':
            return null;
        default:
            return state;
    }
}

export default reducer;
